import React from 'react';
import { Link } from 'react-router-dom';
import { useButtonLinks } from '../hooks/useButtonLinks';
import { useTranslation } from '../hooks/useTranslation';

const AccountTypes = () => {
  const { handleButtonClick } = useButtonLinks();
  const { t } = useTranslation();
  const handleAccountClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const accountTypes = [
    {
      id: 1,
      name: 'Pro',
      spreads_from: '1 pips',
      commission: '$0',
      leverage: '1:400',
      stop_out: '20%',
      platform: 'MT5',
      min_deposit: '$20',
      islamic_accounts: 'Available',
      execution: 'Market',
      min_order: '0.01',
      currency: 'USD',
      hedging: 'Yes',
      ea: 'Allowed',
      instruments: 'FX, Metals, Commodities, Indices, Shares CFDs',
      link: '/accounts/pro'
    },
    {
      id: 2,
      name: 'Prime',
      spreads_from: '0 pips',
      commission: '$6',
      leverage: '1:400',
      stop_out: '20%',
      platform: 'MT5',
      min_deposit: '$250',
      islamic_accounts: 'Available',
      execution: 'Market',
      min_order: '0.01',
      currency: 'USD',
      hedging: 'Yes',
      ea: 'Allowed',
      instruments: 'FX, Metals, Commodities, Indices, Shares CFDs',
      link: '/accounts/prime'
    },
    {
      id: 3,
      name: 'Premium',
      spreads_from: '0 pips',
      commission: '$3',
      leverage: '1:400',
      stop_out: '20%',
      platform: 'MT5',
      min_deposit: '$3000',
      islamic_accounts: 'Available',
      execution: 'Market',
      min_order: '0.01',
      currency: 'USD',
      hedging: 'Yes',
      ea: 'Allowed',
      instruments: 'FX, Metals, Commodities, Indices, Shares CFDs',
      link: '/accounts/premium'
    }
  ];

  return (
    <section id="accounts" className="account-types">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('accountTypes.title')}</h2>
          <p className="section-subtitle">
            {t('accountTypes.subtitle')}
          </p>
        </div>
        
        <div className="accounts-grid">
          {accountTypes.map((account, index) => (
            <div key={account.id} className={`account-card ${account.name.toLowerCase()}-account hover-lift`}>
              <div className="account-header">
                <h3 className="account-name">{account.name}</h3>
              </div>
              
              <div className="account-details">
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.spreadsFrom')}</span>
                  <span className="feature-value">{account.spreads_from}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.commission')}</span>
                  <span className="feature-value">{account.commission}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.leverage')}</span>
                  <span className="feature-value">{account.leverage}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.stopOut')}</span>
                  <span className="feature-value">{account.stop_out}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.platform')}</span>
                  <span className="feature-value">{account.platform}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.minDeposit')}</span>
                  <span className="feature-value highlight">{account.min_deposit}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.islamicAccounts')}</span>
                  <span className="feature-value">{account.islamic_accounts === 'Available' ? t('accountTypes.labels.available') : account.islamic_accounts}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.execution')}</span>
                  <span className="feature-value">{account.execution === 'Market' ? t('accountTypes.labels.market') : account.execution}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.minOrder')}</span>
                  <span className="feature-value">{account.min_order}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.currency')}</span>
                  <span className="feature-value">{account.currency}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.hedging')}</span>
                  <span className="feature-value">{account.hedging === 'Yes' ? t('accountTypes.labels.yes') : account.hedging}</span>
                </div>
                <div className="account-feature">
                  <span className="feature-label">{t('accountTypes.labels.ea')}</span>
                  <span className="feature-value">{account.ea === 'Allowed' ? t('accountTypes.labels.allowed') : account.ea}</span>
                </div>
                <div className="account-feature full-width">
                  <span className="feature-label">{t('accountTypes.labels.instruments')}</span>
                  <span className="feature-value">{t('accountTypes.labels.instrumentsText')}</span>
                </div>
              </div>
              
              <div className="account-actions">
                <Link to={account.link} className="btn btn-secondary" onClick={handleAccountClick}>
                  {t('accountTypes.buttons.findOutMore')}
                </Link>
                <button 
                  className="btn btn-primary"
                  onClick={(e) => handleButtonClick('openAccount', e)}
                >
                  {t('accountTypes.buttons.createAccount')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccountTypes;